import React from 'react';
import { IconProps } from '../DefaultIcon';

export function PawnsIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="83"
      viewBox="0 0 80 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_5_5217)">
        <path
          d="M60.5279 82.5806H2.81525C1.17302 82.5806 0 81.173 0 79.7654V19.0029L14.0762 4.92664H60.5279C62.1701 4.92664 63.3431 6.09966 63.3431 7.74189V79.7654C63.3431 81.173 62.1701 82.5806 60.5279 82.5806Z"
          fill="#EAEEF9"
        />
        <path
          d="M52.7858 38.7097C52.5512 38.7097 52.5512 38.7097 52.3166 38.4751C51.8474 38.2405 51.6128 37.5367 51.8474 37.0675C52.082 36.8329 54.8973 31.6716 61.2316 32.61C61.7008 32.61 62.17 33.3138 62.17 33.783C62.17 34.2522 61.4662 34.7214 60.997 34.7214C56.3049 34.0176 53.9588 38.0059 53.7242 38.0059C53.4896 38.4751 53.255 38.7097 52.7858 38.7097Z"
          fill="#FBFCFE"
        />
        <path
          d="M34.4868 25.8064C30.9678 25.8064 28.6217 26.5102 27.6833 26.9794C27.2141 27.214 26.9795 26.9794 26.7449 26.5102C24.1642 21.3489 19.7068 19.2375 17.5953 18.5337C17.1261 18.5337 16.6569 18.7683 16.6569 19.2375C16.4223 21.5835 15.9531 27.9179 17.8299 30.9677C17.8299 31.4369 17.8299 31.6715 17.5953 31.9061C14.0763 34.956 11.4956 38.9443 10.7918 43.6363C10.7918 43.6363 9.14959 46.217 4.92671 46.6862C4.4575 46.6862 4.2229 47.1554 4.2229 47.39V55.3665C4.4575 56.0704 4.69211 56.305 5.16132 56.305C7.27275 56.5396 12.9033 57.2434 15.4839 59.5894C16.6569 60.997 17.8299 62.1701 19.4722 63.1085C19.4722 63.1085 22.0528 68.5044 20.6452 74.1349C20.6452 74.6041 20.8798 75.0733 21.349 75.0733H29.0909C29.5601 75.0733 30.0294 74.6041 29.7947 74.1349C29.5601 72.7272 29.3255 69.912 30.264 67.0967C30.264 67.0967 35.1906 68.9736 39.6481 66.6275C40.5865 69.912 40.1173 72.7272 39.6481 73.9003C39.8827 74.6041 40.1173 75.0733 40.5865 75.0733H48.3285C48.7977 75.0733 49.0323 74.8387 49.0323 74.3695C49.2669 61.4662 56.5396 60.0586 56.5396 47.1554C56.7742 35.6598 48.0939 25.8064 34.4868 25.8064Z"
          fill="#FBFCFE"
        />
        <path
          d="M22.522 40.1173C22.522 41.9941 21.1144 43.4018 19.2376 43.4018C17.3607 43.4018 15.9531 41.9941 15.9531 40.1173C15.9531 38.2405 17.3607 36.8328 19.2376 36.8328C20.8798 36.5982 22.522 38.2405 22.522 40.1173Z"
          fill="#00C4B3"
        />
        <path
          d="M23.6951 47.39C23.6951 53.4897 28.6218 58.4164 34.7215 58.4164C40.8212 58.4164 45.7479 53.4897 45.7479 47.39C45.7479 41.2903 40.8212 36.3636 34.7215 36.3636C28.6218 36.3636 23.6951 41.2903 23.6951 47.39Z"
          fill="#00416B"
        />
        <path
          d="M39.1789 50.2053L41.525 51.3783C40.3519 53.2552 38.4751 54.6628 35.8945 54.6628C32.61 54.6628 30.264 52.786 29.5602 49.9707H27.2141L28.3871 48.0939H29.3255C29.3255 47.8593 29.3255 47.8593 29.3255 47.6247V47.3901H27.2141L28.3871 45.5132H29.5602C30.264 42.698 32.8446 40.5865 35.8945 40.5865C38.4751 40.5865 40.5865 41.7596 41.525 43.871L39.1789 45.044C38.4751 43.871 37.3021 43.1672 35.8945 43.1672C34.2522 43.1672 32.8446 44.1056 32.3754 45.2786H38.9443L37.5367 47.1555H31.6716V47.3901C31.6716 47.6247 31.6716 47.6247 31.6716 47.8593H37.3021L36.3637 49.7361H32.1408C32.8446 51.1437 34.0176 51.8475 35.6599 51.8475C37.3021 51.8475 38.4751 51.1437 39.1789 50.2053Z"
          fill="white"
        />
        <path
          d="M76.481 55.3665C75.5426 55.3665 74.6042 55.1319 73.9004 54.4281L45.7479 26.2756C44.3402 24.868 44.3402 22.5219 45.7479 21.1143C47.1555 19.7067 49.5015 19.7067 50.9091 21.1143L79.0616 49.2668C80.4693 50.6744 80.4693 53.0205 79.0616 54.4281C78.3578 54.8973 77.4194 55.3665 76.481 55.3665Z"
          fill="#00C4B3"
        />
        <path
          d="M46.2465 4.77459L28.3306 22.6906L40.9381 35.2981L58.8541 17.3821L46.2465 4.77459Z"
          fill="#00416B"
        />
        <path
          d="M60.0588 16.4223L62.6394 13.8417C64.2816 12.1995 64.2816 9.85343 62.6394 8.2112L55.6013 1.17308C53.9591 -0.469151 51.613 -0.469151 49.9708 1.17308L47.3901 3.75372L60.0588 16.4223Z"
          fill="#00C4B3"
        />
        <path
          d="M27.4488 23.6951L24.8681 26.2757C23.2259 27.9179 23.2259 30.264 24.8681 31.9062L31.9063 38.9443C33.5485 40.5866 35.8945 40.5866 37.5368 38.9443L40.1174 36.3637L27.4488 23.6951Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_5217">
          <rect width="80" height="82.5807" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
